import { useRef } from "react";
import { normalizeOtp } from "../auth/otp";

export function OtpInput({ value, onChange, onComplete, disabled, arabic, length = 4 }: {
  value: string; onChange: (value: string) => void;
  onComplete: (value: string) => void; disabled: boolean; arabic: boolean; length?: number;
}) {
  const inputs = useRef<(HTMLInputElement | null)[]>([]);
  // Spaces retain empty middle cells when a digit is removed.
  const count = Number.isInteger(length) && length >= 4 && length <= 10 ? length : 4;
  const cells = value.padEnd(count, " ").slice(0, count).split("");
  function update(index: number, raw: string) {
    const digits = normalizeOtp(raw, count);
    const next = [...cells];
    const start = digits.length === count ? 0 : index;
    if (!digits) next[index] = " ";
    else for (let i = 0; i < digits.length && start + i < count; i++) next[start + i] = digits[i];
    const code = next.join("");
    onChange(code);
    if (digits) inputs.current[Math.min(start + digits.length, count - 1)]?.focus();
    if (new RegExp(`^\\d{${count}}$`).test(code)) onComplete(code);
  }
  return <div className="otp-fields" style={{ gridTemplateColumns: `repeat(${count}, minmax(0, 1fr))`, ...(count > 6 ? { gap: 4 } : {}) }} role="group" aria-labelledby="otp-label" dir="ltr">
    {cells.map((digit, index) => <input
      key={index}
      ref={(element) => { inputs.current[index] = element; }}
      aria-label={arabic ? `الرقم ${index + 1} من رمز التحقق` : `Verification digit ${index + 1}`}
      aria-describedby="otp-hint"
      type="text" inputMode="numeric" autoComplete={index === 0 ? "one-time-code" : "off"}
      maxLength={count} pattern="[0-9]" required disabled={disabled}
      value={digit.trim()} autoFocus={index === 0}
      onFocus={(event) => event.currentTarget.select()}
      onChange={(event) => update(index, event.target.value)}
      onPaste={(event) => { event.preventDefault(); update(index, event.clipboardData.getData("text")); }}
      onKeyDown={(event) => {
        if (event.key === "Backspace" && !digit.trim() && index > 0) {
          event.preventDefault(); update(index - 1, ""); inputs.current[index - 1]?.focus();
        } else if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
          event.preventDefault(); inputs.current[index + (event.key === "ArrowLeft" ? -1 : 1)]?.focus();
        }
      }}
    />)}
  </div>;
}
